function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { nsauth } from "../../i18n/namespaces";
import { useTranslation } from 'react-i18next';
import { setDocumentLang } from '@isyc-react/core/utils/accessibility';
import { languages } from '@isyc-react/core/languages';
import { AuthContext } from "./auth.context";
import { useUserReadCurrentLazyQuery } from "./auth.dev";
import { AuthStatus, createEmptyUserSession } from "./auth.vm";
import { useRouterInitialLocationPersist } from "../base";
// TODO allow passing some function to modify login and user get ... (and dev things ...)

export const AuthProvider = props => {
  const {
    children,
    checkLoggedIn = true
  } = props;
  const {
    i18n
  } = useTranslation(nsauth.common);
  useRouterInitialLocationPersist();
  const urlLocale = React.useRef(undefined);
  const [userSession, setUserSession] = React.useState(createEmptyUserSession(checkLoggedIn ? AuthStatus.LOADING : AuthStatus.NOT_LOGGED));

  // console.log('USER SESSION: ',userSession)

  const [readUserCurrent, {
    data,
    error
  }] = useUserReadCurrentLazyQuery();
  React.useEffect(() => {
    setDocumentLang();
    if (checkLoggedIn) {
      readUserCurrent();
    }
  }, []);
  React.useEffect(() => {
    if (error) {
      if (error.networkError && error.networkError['statusCode'] === 401) {
        // Unauthorized, not already logged in
        setUserSession({
          user: null,
          status: AuthStatus.NOT_LOGGED
        });
      } else {
        // Generic error
        setUserSession({
          user: null,
          status: AuthStatus.ERROR
        });
      }
    }
  }, [error]);
  React.useEffect(() => {
    if (data && data.user_read_current) {
      var _data$user_read_curre;
      setUserSession({
        user: data.user_read_current,
        status: AuthStatus.LOGGED
      });
      const userLanguage = (_data$user_read_curre = data.user_read_current.language) === null || _data$user_read_curre === void 0 ? void 0 : _data$user_read_curre.toLowerCase();
      if (!urlLocale.current && i18n.language !== userLanguage) {
        setDocumentLang(userLanguage);
        i18n.changeLanguage(userLanguage);
      }
    }
  }, [data]);
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const locale = params.get('locale');
    if (locale && Object.values(languages).some(lang => lang === locale.toLowerCase())) {
      urlLocale.current = decodeURIComponent(locale).toLowerCase();
      setDocumentLang(urlLocale.current);
      i18n.changeLanguage(urlLocale.current);
    }
  }, []);
  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: _objectSpread(_objectSpread({}, userSession), {}, {
      setUserSession,
      refresh: readUserCurrent,
      urlLocale
    })
  }, children);
};